import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, AlertTriangle, Moon, CircleDashed } from 'lucide-react';

/**
 * iter165 — Health chip for the Subscribers list + user drawer.
 * Uses the SAME status buckets as backend `compute_health_status`.
 */
const CONFIG = {
  healthy: {
    label: 'Healthy',
    Icon: CheckCircle2,
    className: 'bg-emerald-900/30 text-emerald-200 border border-emerald-500/30',
  },
  at_risk: {
    label: 'At risk',
    Icon: AlertTriangle,
    className: 'bg-amber-900/30 text-amber-200 border border-amber-500/30',
  },
  dormant: {
    label: 'Dormant',
    Icon: Moon,
    className: 'bg-rose-900/30 text-rose-200 border border-rose-500/30',
  },
  never_activated: {
    label: 'Never activated',
    Icon: CircleDashed,
    className: 'bg-slate-800 text-slate-400 border border-slate-700',
  },
};

export default function HealthChip({ status, compact = false }) {
  const cfg = CONFIG[status] || CONFIG.never_activated;
  const { Icon, label, className } = cfg;
  return (
    <Badge variant="secondary" className={`${className} gap-1 whitespace-nowrap`} data-testid={`health-chip-${status}`}>
      <Icon className="h-3 w-3" />
      {!compact && label}
    </Badge>
  );
}
